"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Card } from "@/components/ui/card";
export default function Testimonials() {
  const reduceMotion = useReducedMotion();
  const testimonials = [{
    id: 1,
    quote: "Sunil transformed our OTA strategy. We saw a 25% increase in direct bookings within three months. His data-driven approach is truly unmatched.",
    name: "Rajesh V.",
    attribution: "General Manager, Grand Plaza",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_manager_rajesh.png",
    blob: "M60,10 C85,10 95,35 95,55 C95,80 75,95 50,95 C25,95 5,80 5,55 C5,30 35,10 60,10 Z",
    offset: "md:mt-0",
    tilt: -2
  }, {
    id: 2,
    quote: "The revenue audit provided by HotelRevBaBa was eye-opening. We identified hidden leaks in our tech stack and optimized our pricing instantly.",
    name: "Sarah L.",
    attribution: "Owner, Boutique Suites",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_owner_sarah.webp",
    blob: "M50,5 C80,10 95,30 90,60 C85,88 60,98 35,92 C10,86 2,55 8,30 C14,10 30,3 50,5 Z",
    offset: "md:mt-16",
    tilt: 2
  }, {
    id: 3,
    quote: "Sunil’s expertise in hospitality tech is incredible. He helped us implement a new PMS that streamlined our operations and boosted our bottom line.",
    name: "Amit K.",
    attribution: "Director, City Hotels",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_director_amit.webp",
    blob: "M55,8 C82,12 92,38 88,62 C84,88 62,96 38,90 C14,84 4,60 10,35 C15,15 32,5 55,8 Z",
    offset: "md:mt-32",
    tilt: -2
  }];
  const confetti = [{
    top: "8%",
    left: "5%",
    type: "seed",
    rotate: -20,
    color: "var(--primary)"
  }, {
    top: "14%",
    left: "92%",
    type: "squiggle",
    rotate: 15,
    color: "var(--chart-3)"
  }, {
    top: "42%",
    left: "3%",
    type: "sprig",
    rotate: 45,
    color: "var(--chart-2)"
  }, {
    top: "68%",
    left: "95%",
    type: "seed",
    rotate: 30,
    color: "var(--primary)"
  }, {
    top: "88%",
    left: "8%",
    type: "squiggle",
    rotate: -30,
    color: "var(--chart-3)"
  }, {
    top: "80%",
    left: "88%",
    type: "sprig",
    rotate: -15,
    color: "var(--chart-2)"
  }, {
    top: "25%",
    left: "48%",
    type: "seed",
    rotate: 60,
    color: "var(--primary)"
  }, {
    top: "55%",
    left: "50%",
    type: "squiggle",
    rotate: -45,
    color: "var(--chart-2)"
  }];
  const renderDoodle = (type: string, color: string) => {
    if (type === "seed") {
      return <svg width="20" height="28" viewBox="0 0 20 28" fill="none">
          <ellipse cx="10" cy="14" rx="7" ry="12" fill={color} />
        </svg>;
    }
    if (type === "squiggle") {
      return <svg width="40" height="16" viewBox="0 0 40 16" fill="none">
          <path d="M2 8 Q10 2, 18 8 T34 8" stroke={color} strokeWidth="2.2" strokeLinecap="round" fill="none" />
        </svg>;
    }
    return <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M14 24 Q14 14, 22 8" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M14 24 Q14 16, 6 12" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
      </svg>;
  };
  return <section data-section-id="26381" id="casestudiestestimonials" data-nav="light" className="relative overflow-hidden bg-background py-24 md:py-32">
      {confetti.map((c, i) => <motion.div data-index={i} key={i} className="pointer-events-none absolute hidden opacity-40 md:block" style={{
      top: c.top,
      left: c.left
    }} animate={reduceMotion ? undefined : {
      y: [0, -4, 0, 4, 0],
      rotate: [c.rotate, c.rotate + 3, c.rotate]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut",
      delay: i * 0.3
    }}>
          {renderDoodle(c.type, c.color)}
        </motion.div>)}
      <div className="pointer-events-none absolute top-4 left-4 opacity-40 md:hidden">
        {renderDoodle("seed", "var(--primary)")}
      </div>
      <div className="pointer-events-none absolute top-8 right-6 opacity-40 md:hidden">
        {renderDoodle("squiggle", "var(--chart-2)")}
      </div>
      <div className="pointer-events-none absolute bottom-6 left-6 opacity-40 md:hidden">
        {renderDoodle("sprig", "var(--chart-3)")}
      </div>
      <div className="pointer-events-none absolute right-4 bottom-4 opacity-40 md:hidden">
        {renderDoodle("seed", "var(--primary)")}
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div className="mx-auto max-w-[720px] text-center" initial={reduceMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.52,
        ease: [0.34, 1.56, 0.64, 1]
      }}>
          <span className="inline-flex items-center gap-2 rounded-lg px-4 py-1.5 text-xs font-semibold tracking-[0.14em] uppercase" style={{
          backgroundColor: "var(--accent)",
          color: "var(--accent-foreground)"
        }}>
            Success Stories
          </span>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.2vw,3.6rem)] leading-[1.02] tracking-[-0.015em] font-medium" style={{
          color: "var(--foreground)"
        }}>
            Proven revenue{" "}
            <span className="relative inline-block">
              <em className="font-serif not-italic" style={{
              color: "var(--primary)",
              fontStyle: "italic",
              fontWeight: 400
            }}>
                results
              </em>
              <svg className="absolute -bottom-2 left-0 w-full" height="14" viewBox="0 0 120 14" fill="none" preserveAspectRatio="none" aria-hidden="true">
                <path d="M2 8 Q30 2, 60 8 T118 8" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                <ellipse cx="20" cy="12" rx="1.5" ry="2" fill="var(--foreground)" />
                <ellipse cx="60" cy="12" rx="1.5" ry="2" fill="var(--foreground)" />
                <ellipse cx="100" cy="12" rx="1.5" ry="2" fill="var(--foreground)" />
              </svg>
            </span>
          </h2>
          <p className="mt-6 text-base md:text-lg leading-[1.6]" style={{
          color: "var(--muted-foreground)"
        }}>
            See how hotel owners and managers use our data-driven strategies to maximize revenue and streamline operations.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:mt-20 md:grid-cols-3 md:gap-6 lg:gap-8">
          {testimonials.map((t, i) => <motion.div data-index={i} key={t.id} className={`${t.offset}`} initial={reduceMotion ? false : {
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.52,
          delay: reduceMotion ? 0 : i * 0.1,
          ease: [0.34, 1.56, 0.64, 1]
        }}>
              <motion.div style={{
            rotate: `${t.tilt}deg`
          }} className="md:rotate-0" whileHover={reduceMotion ? undefined : {
            rotate: 1.5,
            y: -4
          }} transition={{
            duration: 0.35,
            ease: [0.34, 1.56, 0.64, 1]
          }}>
                <Card className="relative flex flex-col gap-5 border-0 p-8 shadow-lg md:p-9" style={{
              backgroundColor: "var(--card)",
              clipPath: `path('${t.blob.replace(/(\d+(?:\.\d+)?)/g, m => `${parseFloat(m) * 6}`)}')`,
              minHeight: "340px"
            }}>
                  <div aria-hidden="true" className="font-serif italic leading-none" style={{
                color: "var(--primary)",
                fontSize: "5rem",
                fontWeight: 400,
                height: "2.5rem"
              }}>
                    &ldquo;
                  </div>

                  <p className="text-base leading-[1.6] md:text-[1.05rem]" style={{
                color: "var(--foreground)"
              }}>
                    {t.quote}
                  </p>

                  <svg className="mt-auto w-full" height="10" viewBox="0 0 200 10" preserveAspectRatio="none" aria-hidden="true">
                    <path d="M0 5 Q25 0, 50 5 T100 5 T150 5 T200 5" stroke="var(--chart-2)" strokeWidth="2" strokeLinecap="round" fill="none" />
                  </svg>

                  <div className="flex items-center gap-4">
                    <div className="relative h-14 w-14 shrink-0 overflow-hidden" style={{
                  clipPath: "path('M28 2 C44 4, 54 16, 52 32 C50 48, 36 56, 22 54 C8 52, 0 38, 2 24 C4 10, 14 0, 28 2 Z')",
                  backgroundColor: "var(--muted)"
                }}>
                      <img src={t.avatar} alt={`Portrait of ${t.name}, HotelRevBaBa client`} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-base font-semibold leading-tight" style={{
                    color: "var(--foreground)"
                  }}>
                        {t.name}
                      </span>
                      <span className="mt-0.5 text-sm leading-tight" style={{
                    color: "var(--muted-foreground)"
                  }}>
                        — {t.attribution}
                      </span>
                    </div>
                  </div>
                </Card>
              </motion.div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}